export default "__VITE_ASSET__bf22819e__"